export enum LocaleDateFormat {
  DE = 'AUSTRIA_GERMANY_SWITZERLAND',
  EN = 'FRANCE_SPAIN_UNITED_KINGDOM',
  US = 'UNITED_STATES',
}
